<div class="m-n5" class="full-size">

  @if (thisProjectTypeId === 5) {
    <div>
      <div style="padding-top:5px"></div>
      <!--     component: Production Volumes    -->
      <app-production-volumes #ProductionVolumesComponent>
      </app-production-volumes>
      <div style="padding-top:5px"></div>
      <!--     component: Pipeline    -->
      <app-pipeline [xProjectId]="thisProjectId" #PipelineComponentComponent>
      </app-pipeline>
      <div style="padding-top:5px"></div>
      <!--     component: Gas Lift    -->
      <app-gas-lift-line [xProjectId]="thisProjectId" #GasLiftLineComponent>
      </app-gas-lift-line>
      <div style="padding-top:5px"></div>
      <!--     component: Well Connect    -->
      <app-well-connect-surface-equipment [xProjectId]="thisProjectId" #WellConnectSurfaceEquipmentComponent>
      </app-well-connect-surface-equipment>
    </div>
  }

  @else if (thisProjectTypeId === 21) {
    <div>
      <app-project-drilling-details [xProjectId]="thisProjectId" [xProjectTypeId]="thisProjectTypeId"
        [iProjectStatusId]="projectStatusId" (saveComplete)="drillingSaveComplete($event)" (tabTdv)="readDrillingParametersTabTdv($event)" #DrillingDetailComponent>
      </app-project-drilling-details>
    </div>
  }

  @else if (thisProjectTypeId === 1) {
    <div>
      <app-project-tank-battery-details [xProjectId]="thisProjectId" #TankBatteryDetailComponent>
      </app-project-tank-battery-details>
    </div>
  }

  @else if (thisProjectTypeId === 22 || thisProjectTypeId === 58 || thisProjectTypeId === 59) {
    <div>
      <app-project-completion-details [iProjectId]="thisProjectId" [iProjectTypeId]="thisProjectTypeId"
        [iProjectStatusId]="projectStatusId" (saveComplete)="completionsSaveComplete($event)" (tabTdv)="readCompletionParametersTabTdv($event)" #CompletionDetailComponent>
      </app-project-completion-details>
    </div>
  }

  @else if (thisProjectTypeId === 17 || thisProjectTypeId === 50) {
    <div>
      <app-project-pond-build [iProjectId]="thisProjectId" [iProjectStatusId]="projectStatusId"
        (tabTdv)="readPondBuildTabTdv($event)" [canEdit]="true" #PondBuildComponent>
      </app-project-pond-build>
    </div>
  }

  @else if (thisProjectTypeId === 57) {
    <div>
      <app-project-pad-construction-details [iProjectId]="thisProjectId" [iProjectTypeId]="thisProjectTypeId" [iProjectTab]="thisProjectTab"
        [iProjectStatusId]="projectStatusId" (tabTdv)="readPadConstructionParametersTabTdv($event)" #PadConstructionDetailComponent>
      </app-project-pad-construction-details>
    </div>
  }

  @else if (thisProjectTypeId === 60) {
    <div>
      <app-project-flowline-details [iProjectId]="thisProjectId" [iProjectTypeId]="thisProjectTypeId"
        [iProjectStatusId]="projectStatusId" (tabTdv)="readFlowlineParametersTabTdv($event)" #FlowlineDetailComponent>
      </app-project-flowline-details>
    </div>
  }
  @else if (thisProjectTypeId === 62) {
    <div>
      <app-project-well-hookup-details [iProjectId]="thisProjectId" [iProjectTypeId]="thisProjectTypeId"
        [iProjectStatusId]="projectStatusId" (tabTdv)="readWellHookupParametersTabTdv($event)" #WellHookupDetailComponent>
      </app-project-well-hookup-details>
    </div>
  }
  @else if (thisProjectTypeId === 61) {
    <div>
      <app-project-well-pad-details [iProjectId]="thisProjectId" [iProjectTypeId]="thisProjectTypeId"
        [iProjectStatusId]="projectStatusId" (tabTdv)="readWellPadParametersTabTdv($event)" #WellPadDetailComponent>
      </app-project-well-pad-details>
    </div>
  }

</div>